import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import Login from './components/pages/Login.vue';
import Register from './components/pages/Register.vue';
import Forgot from './components/pages/Forgot.vue';
import Reset from './components/pages/Reset.vue';
import CampaignList from './components/pages/CampaignList.vue';
import Profile from './components/pages/Profile.vue';
import CampaignMap from './components/pages/CampaignMap.vue';
import CampaignLocations from './components/pages/CampaignLocations.vue';
import CampaignTeams from './components/pages/CampaignTeams.vue';
import CampaignReports from './components/pages/CampaignReports.vue';
import AddLocation from './components/pages/AddLocation.vue';
import EditLocation from './components/pages/EditLocation.vue';
import EditLocationOffline from './components/pages/EditLocationOffline.vue';
import CampaignSettings from './components/pages/CampaignSettings.vue';
import LocationsList from './components/pages/LocationsList.vue';
import notFound from './components/pages/notFound.vue';
import OfflineCampaign from './components/pages/OfflineCampaign.vue';
import Offline from './components/pages/Offline.vue';

Vue.use(Router)

//Define routes
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: CampaignList,
      beforeEnter : loginGuard,
    },
    {
      path: '/campaign-list',
      name: 'campaign_list',
      component: CampaignList,
      beforeEnter : loginGuard,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter : loginAndOffline,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter : loginGuard,
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        beforeEnter : loginGuard,
    },
    {
        path: '/forgot',
        name: 'forgot',
        component: Forgot,
        beforeEnter : loginGuard,
    },
    {
      path: '/reset',
      name: 'reset-application',
      component: Reset,
      beforeEnter : loginGuard,
    },
    {
      path: '/reset/:token',
      name: 'reset-token',
      component: Reset,
      beforeEnter : loginGuard,
    },
    {
      path: '/confirm/:token',
      name: 'confirm',
      component: Login,
      beforeEnter : loginGuard,
    },
    {
      path: '/campaign-map/:campaign_id',
      name: 'campaign-map',
      component: CampaignMap,
      beforeEnter : loginGuard,
      props: true
    },
    {
      path: '/campaign-locations/:campaign_id',
      name: 'campaign-locations',
      component: CampaignLocations,
      beforeEnter : loginGuard,
    },
    {
      path: '/campaign-teams/:campaign_id',
      name: 'campaign-teams',
      component: CampaignTeams,
      beforeEnter : loginAndOffline,
    },
    {
      path: '/campaign-reports/:campaign_id',
      name: 'campaign-reports',
      component: CampaignReports,
      beforeEnter : loginAndOffline,
    },
    {
      path: '/add-location/:campaign_id',
      name: 'add-location',
      component: AddLocation,
      beforeEnter : loginGuard,
    },
    {
      path: '/edit-location/:campaign_id/:location_id/:respondent_id',
      name: 'edit-location',
      component: EditLocation,
      beforeEnter : loginGuard,
    },
    {
      path: '/edit-location-offline/:campaign_id',
      name: 'edit-location-offline',
      component: EditLocationOffline,
      beforeEnter : loginGuard,
    },
    {
      path: '/locations-list/:campaign_id/:location_id',
      name: 'locations-list',
      component: LocationsList,
      beforeEnter : loginGuard,
    },
    {
      path: '/campaign-settings/:campaign_id',
      name: 'campaign-settings',
      component: CampaignSettings,
      beforeEnter : loginAndOffline,
      props: true
    },
    {
      path: '/campaign-settings-offline/:campaign_id',
      name: 'campaign-settings-offline',
      component: Offline,
      props: true
    },
    {
      path: '/offline',
      name: 'offline',
      component: Offline,
      props: true
    },
    {
      path: '/offline-profile',
      name: 'offline-profile',
      component: Offline,
      props: true
    },
    {
      path: '/offline-campaign/:campaign_id',
      name: 'offline-campaign',
      component: OfflineCampaign,
      props: true
    },
    {
      path: '/offline-campaign-teams/:campaign_id',
      name: 'offline-campaign-teams',
      component: OfflineCampaign,
      props: true
    },
    {
      path: '/offline-campaign-reports/:campaign_id',
      name: 'offline-campaign-reports',
      component: OfflineCampaign,
      props: true
    },
    {
      path: '/404',
      name: 'not-found',
      component: notFound,
      beforeEnter : loginGuard,
      props: true
    },
    { path: "*", component: notFound }
  ]
});

//Define guards
function loginGuard(to, from, next) {
  if (
    typeof store.getters.token == 'undefined' && 
    to.name !== 'login' && 
    to.name !== 'register' && 
    to.name !== 'forgot' &&
    to.name !== 'reset-token' &&
    to.name !== 'confirm'
  ) {
    next({ name: 'login' });
  } else {
    next();
  }
}

function offlineGuard(to, from, next) {
  if (!store.getters.online) {
    var goto = '';
    if (to.name == 'profile') {
      goto = 'offline-profile';
    } else if (to.name == 'campaign-teams') {
      goto = 'offline-campaign-teams';
    } else if (to.name == 'campaign-reports') {
      goto = 'offline-campaign-reports';
    } else if (to.name == 'campaign-settings') {
      goto = 'campaign-settings-offline';
    } else {
      goto = 'offline';
    }
    next({ name: goto });
  } else {
    next();
  }
}

function loginAndOffline(to, from, next) {
  loginGuard(to, from, next);
  offlineGuard(to, from, next);
}
